export const OmsErrorCodes = {
    TurnstileVerificationFailed: 1005,
    TurnstileVerificationUnavailable: 1006,
} as const;

export function getOmsErrorCode(error: any): number | undefined {
    const code = error?.response?.data?.errorCode;
    return typeof code === 'number' ? code : undefined;
}
